import React from 'react';
import { siteData } from '../../data/mock';

const HighlightsTable = () => {
  const { highlights } = siteData;

  const icons = ['\u{1F4CB}', '\u{1F4B0}', '\u{1F4DD}', '\u{1F4CA}', '\u{1F30E}'];

  return (
    <section className="py-[60px] md:py-[80px]">
      <div className="max-w-[900px] mx-auto px-4 sm:px-6">
        <h2 className="text-[28px] md:text-[34px] font-bold text-center text-[#1a1a2e] mb-8 md:mb-12 leading-tight">
          {highlights.title}
        </h2>

        <div className="bg-white rounded-xl overflow-hidden shadow-sm border border-gray-100">
          <table className="w-full">
            <tbody>
              {highlights.items.map((item, index) => (
                <tr
                  key={index}
                  className={`${
                    index % 2 === 0 ? 'bg-[#f7f8fc]' : 'bg-white'
                  } border-b border-gray-100 last:border-b-0`}
                >
                  <td className="px-4 md:px-6 py-4 md:py-5">
                    <span className="font-bold text-[14px] md:text-[15px] text-[#1a1a2e]">
                      {icons[index]} {item.label}
                    </span>
                  </td>
                  <td className="px-4 md:px-6 py-4 md:py-5">
                    <span className="text-[14px] md:text-[15px] text-[#4a4a6a]">
                      {item.value}
                    </span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </section>
  );
};

export default HighlightsTable;
